module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Обновляем профиль..."
    }
  }) : _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.beforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newUserData.firstname.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-firstname"
    }
  }, [_vm._v("Имя")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [(_vm.currentUser.isAdmin) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.firstname),
      expression: "newUserData.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "type": "text",
      "id": "user-firstname"
    },
    domProps: {
      "value": (_vm.newUserData.firstname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "firstname", $event.target.value)
      }, function($event) {
        _vm.$v.newUserData.firstname.$touch()
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.firstname),
      expression: "newUserData.firstname"
    }],
    staticClass: "form-control disabled",
    attrs: {
      "disabled": "",
      "name": "firstname",
      "type": "text",
      "id": "user-firstname"
    },
    domProps: {
      "value": (_vm.newUserData.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$v.newUserData.firstname.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Имя обязательно должно быть указано")]) : _vm._e()]), _vm._v(" "), (!_vm.currentUser.isAdmin) ? _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Имя может изменить только администратор")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newUserData.lastname.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-lastname"
    }
  }, [_vm._v("Фамилия")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [(_vm.currentUser.isAdmin) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.lastname),
      expression: "newUserData.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-lastname"
    },
    domProps: {
      "value": (_vm.newUserData.lastname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "lastname", $event.target.value)
      }, function($event) {
        _vm.$v.newUserData.lastname.$touch()
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.lastname),
      expression: "newUserData.lastname"
    }],
    staticClass: "form-control disabled",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "user-lastname"
    },
    domProps: {
      "value": (_vm.newUserData.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$v.newUserData.lastname.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Фамилия обязательно должна быть указана")]) : _vm._e()]), _vm._v(" "), (!_vm.currentUser.isAdmin) ? _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Фамилию может изменить только администратор")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newUserData.email.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-email"
    }
  }, [_vm._v("Электронная почта")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.email),
      expression: "newUserData.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-email"
    },
    domProps: {
      "value": (_vm.newUserData.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "email", $event.target.value)
      }, function($event) {
        _vm.$v.newUserData.email.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.newUserData.email.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Адрес электронной почты обязателен и должен быть валидным")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("На данный адрес будут приходить оповещения, также этот адрес используется для авторизации в Аларм Плане")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newUserData.phone.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-sm-2 col-form-label",
    attrs: {
      "for": "user-phone"
    }
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("+7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.phone),
      expression: "newUserData.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-phone"
    },
    domProps: {
      "value": (_vm.newUserData.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "phone", $event.target.value)
      }, function($event) {
        _vm.$v.newUserData.phone.$touch()
      }]
    }
  })]), _vm._v(" "), (_vm.$v.newUserData.phone.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Телефон обязателен и должен состоять из 10 цифр")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("На данный номер будут приходить оповещения. Настроить оповещения можно в следующей вкладке")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label"
  }, [_vm._v("Дата рождения")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('datepicker', {
    attrs: {
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.newUserData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.newUserData, "birthday", $$v)
      },
      expression: "newUserData.birthday"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Мы поздравим Вас, когда прийдёт время")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-skype"
    }
  }, [_vm._v("Skype")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.skype),
      expression: "newUserData.skype"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-skype"
    },
    domProps: {
      "value": (_vm.newUserData.skype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "skype", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-icq"
    }
  }, [_vm._v("Icq")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.icq),
      expression: "newUserData.icq"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-icq"
    },
    domProps: {
      "value": (_vm.newUserData.icq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "icq", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Кто помнит что это??? :D")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-icq"
    }
  }, [_vm._v("Id пользователя в Телеграм")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.telegramUserId),
      expression: "newUserData.telegramUserId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-telegram"
    },
    domProps: {
      "value": (_vm.newUserData.telegramUserId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "telegramUserId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Для того, чтобы получать уведомления в Телеграм необходимо указать id пользователя. Для этого подключитьсеь к боту "), _c('a', {
    attrs: {
      "href": "https://t.me/AlarmPlanBot?start ",
      "target": "_blank"
    }
  }, [_vm._v("@AlarmPlanBot")]), _vm._v(", нажав "), _c('b', [_vm._v("Start")]), _vm._v(", в ответ бот пришлет вам id, который необходимо тут указать")])])]), _vm._v(" "), (_vm.currentUser.isAdmin) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-icq"
    }
  }, [_vm._v("Id пользователя в AmoCrm")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.amoId),
      expression: "newUserData.amoId"
    }],
    staticClass: "form-control",
    class: {
      'disabled': !_vm.currentUser.isAdmin
    },
    attrs: {
      "type": "text",
      "id": "user-amo-id",
      "disabled": !_vm.currentUser.isAdmin
    },
    domProps: {
      "value": (_vm.newUserData.amoId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "amoId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "offset-sm-2 col-sm-10"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': _vm.$v.newUserData.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newUserData.$invalid,
      "type": "submit"
    }
  }, [_vm._v("Сохранить")])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a96c4ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-2a96c4ea"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/ProfileSettings.vue
// module id = 1016
// module chunks = 1